module.exports = __webpack_public_path__ + "static/img/scream.d865492.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/scream.jpg
// module id = omSj
// module chunks = 35